module.exports = __webpack_public_path__ + "img/02_1_2_1.9e06fc0e.png";